// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"35":"ecd594c1","884":"8a16699a"}[chunkId] + ".js";
};